import React from 'react'

function ProductCard({cars}) {
  return (
    <div className="container">
      <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-4 g-5 my-2">
        {
          cars.map(car => {
            return(
              <div className="col text-dark text-start" key={car.id} data-aos="zoom-in-up" data-aos-duration="500">
                <div className="card p-3 card-car-list">
                  <img src={car.image} className="card-img-top" alt="carImage" width="100%" height="100%" style={{objectFit: "contain", maxHeight: "150px", minHeight: "150px"}} />
                  <hr style={{border: "1px solid #DEA300"}}/>
                  <div className="card-body">
                    <h5 className="card-title color-secondary">{car.name}</h5>
                    <p className="card-text m-0 fw-bold mb-2">Transmisi: {car.transmition}</p>
                    <p className="card-text m-0 fw-bold mb-2">Tahun: {car.year}</p>
                    <p className="card-text m-0 fw-bold mb-2">{car.type === "Alat Berat" ? "Jenis" : "Tipe"}: {car.type}</p>
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default ProductCard